// extracted by css-extract-rspack-plugin
export default {"root":"root-fxhJ2V","titleText":"titleText-zUfy53","consentText":"consentText-KoLlqo","consentTextError":"consentTextError-nhD8jS"};